import { render, staticRenderFns } from "./PaymentReceipts.vue?vue&type=template&id=73680e7c&scoped=true&"
import script from "./PaymentReceipts.vue?vue&type=script&lang=js&"
export * from "./PaymentReceipts.vue?vue&type=script&lang=js&"
import style0 from "./PaymentReceipts.vue?vue&type=style&index=0&id=73680e7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73680e7c",
  null
  
)

export default component.exports